import { Container, Group, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png'; // Adjust the path as necessary

export function HeaderMenu() {
    return (
        <Container size="100%" h={60} px="xl">
            <Group justify="space-between" h="100%">
                <Group>
                    <Group gap={8}>
                        <img src={logo} alt="TuboTubo Logo" style={{ height: 47, width: 47 }} />
                        <Anchor
                            component={Link}
                            to="/"
                            c="dark"
                            fw={600}
                            style={{ textDecoration: 'none' }}
                        >
                            TuboTubo
                        </Anchor>
                    </Group>
                </Group>
                <Group>
                    <Anchor
                        component={Link}
                        to="/privacy"
                        c="dark.6"
                        underline="never"
                    >
                          Privacy Policy
                    </Anchor>
                </Group>
            </Group>
        </Container>
    );

}